import { throttle, wrap } from 'lodash-es';
import Cookies from 'js-cookie';

export const Helpers = (function () {
	'use strict';

	function init() {
		cookie_banner();
		responsive_videos();
		accordions();
		back_to_top();
		checkCookie();
		inputAutoComplete();
		customNav();
		topFocus();

		
		


		if (typeof gform !== 'undefined') {
			$(document).on('gform_post_render', gravity_form_submittable);
			// gform.addAction('gform_input_change', gravity_form_submittable);
		}

		// const educationLoginLink = document.querySelector('.nav-items a[href$="/login/"]');
		const registerLinks = document.querySelectorAll(
			'.nav-items a[href$="/register/"], .resource-menu a[href$="/register/"]'
		);

		// console.log(educationLoginLink);

		userIsLoggedIn ??= false;

		if (registerLinks && userIsLoggedIn) {
			// educationLoginLink.setAttribute('href', '/my-account/');
			// educationLoginLink.textContent = 'My Account';

			registerLinks.forEach((registerLink) => {
				registerLink.parentNode.removeChild(registerLink);
			});
		}

		// Remove print certificate button
		const printCertificateButton = document.querySelector(
			'.sfwd-quiz-template-default .wpProQuiz_certificate'
		);

		console.log('print certificate button: ', printCertificateButton);

		if (printCertificateButton) {
			console.log('Removing the print certificate button');
			printCertificateButton.parentNode.removeChild(printCertificateButton);
		}
	}


	
	function checkCookie() {
		let myCookie = Cookies.get('notificationClosed');
		let notificationBar = document.querySelector('.notification-bar');
		if (null === notificationBar) return;

		if (myCookie == 'yes') {
			notificationBar.parentNode.removeChild(notificationBar);
			document.body.style.paddingTop =
				document.querySelector('.site-header').getBoundingClientRect().height + 'px';
		} else {
			notificationBar
				.querySelector('.notification-bar__close')
				.addEventListener('click', (ev) => {
					Cookies.set('notificationClosed', 'yes');
					notificationBar.parentNode.removeChild(notificationBar);
					document.body.style.paddingTop =
						document.querySelector('.site-header').getBoundingClientRect().height +
						'px';
				});
		}
	}

	function gravity_form_submittable() {
		// hide submit button if first option is not selected
		var $form_select = $('.gform_body > ul > li:first-child select');
		var $submit_btn = $('[id^="gform_submit_button_"]');

		if ($form_select) {
			if ($form_select.val() === '') {
				$submit_btn.css('display', 'none');
			} else {
				$submit_btn.css('display', 'block');
			}
		}
		// check for visible required fields
		var $form = $('form[id^="gform_"]');

		if ($form.attr('id') == 'gform_wrapper_3') {
			var $reqd = $form.find('.gfield_contains_required:visible').filter(function (i, c) {
				return []
					.concat(
						$(c)
							.find('input[type="text"], textarea')
							.filter(function (i, fl) {
								return $(fl).val().length == 0;
							})
							.get()
					)
					.concat($(c).find('input[type="checkbox"]').not(':checked').get()).length;
			});
			if ($reqd.length) {
				$form
					.find('input[type="submit"]')
					.addClass('disabled button-disabled')
					.attr('disabled', 'disabled');
			} else {
				$form
					.find('input[type="submit"]')
					.removeClass('disabled button-disabled')
					.removeAttr('disabled');
			}
		}
	}

	function back_to_top() {
		let backToTopButton = document.getElementById('pxBackToTop');

		if (backToTopButton === null) return;

		backToTopButton.addEventListener('click', (ev) =>
			scroll({
				behavior: 'smooth',
				top: 0,
			})
		);

		document.activeElement.blur();
	}

	function cookie_banner() {
		let banner = document.querySelector('.cookie-banner');
		let acceptedCookieStatus = Cookies.get('acceptedCookiePrompt');

		banner?.querySelectorAll('button').forEach((btn) => {
			btn.addEventListener('click', (ev) => {
				ev.preventDefault();

				let acceptance = btn.classList.contains('accept') ? 'yes' : 'no';
				Cookies.set('acceptedCookiePrompt', acceptance);
				window.location.reload();
			});
		});

		if (!banner || acceptedCookieStatus === 'yes') return;

		if (localStorage.getItem('cookieBannerShownOnce') && !acceptedCookieStatus) {
			banner.style.display = 'block';
			return;
		}

		localStorage.setItem('cookieBannerShownOnce', 'true');

		if (!acceptedCookieStatus) banner.style.display = 'block';
	}

	function responsive_videos() {
		let responsiveVideos = document.querySelectorAll('.responsive-video');

		if (!responsiveVideos) return;

		responsiveVideos.forEach((vid) => {
			let playButton = vid.querySelector('.play-button');
			let videoEl = vid.querySelector('video');
			let iframe = vid.querySelector('iframe');
			let cover = vid.querySelector('.responsive-video__cover');

			if (!playButton) return;

			if (iframe) {
				let iframeOriginalSrc = iframe.getAttribute('src');

				iframe.setAttribute('src', iframe.getAttribute('src') + '&showinfo=0&controls=0');
			}

			playButton.addEventListener('click', (ev) => {
				vid.classList.add('playing');
			});

			playButton.addEventListener('transitionend', (ev) => {
				playButton.parentNode.removeChild(playButton);

				if (cover) {
					cover.parentNode.removeChild(cover);
				}

				if (videoEl) {
					videoEl.setAttribute('controls', 'controls');
					videoEl.play();
				}

				if (iframe) {
					iframe.setAttribute('src', iframe.getAttribute('src') + '&autoplay=1');
				}
			});
		});
	}

	// function body_scroll() {
	// 	window.addEventListener(
	// 		'scroll',
	// 		throttle(() => {
	// 			window.scrollY > 100 ? document.body.classList.add('scrolled') : document.body.classList.remove('scrolled');
	// 		}, 150)
	// 	);
	// }

	function getUrlParams(search) {
		if (search.length <= 1) return {};
		const hashes = search.slice(search.indexOf('?') + 1).split('&');
		const params = {};
		hashes.map((hash) => {
			const [key, val] = hash.split('=');
			params[key] = decodeURIComponent(val);
		});
		return params;
	}

	function accordions() {
		let accordions = Array.from(document.querySelectorAll('[data-accordion]'));

		if (accordions.length === 0) return;

		accordions.forEach((accordion) => {
			let trigger = accordion.querySelector('[data-accordion-trigger]');

			trigger.addEventListener('click', (ev) => {
				accordion.classList.toggle('accordion-open');
			});
		});
	}

	function inputAutoComplete() {
		//$('input').attr('autocomplete', 'on');
	}

	function customNav() {
		//$('li.menu-item').unwrap();

		$('li.column--title').each(function () {
			$(this)
				.children('a')
				.replaceWith(function () {
					return $('<span/>', {
						html: this.innerHTML,
					});
					console.log(this);
				});

			var text = $(this).children('span').text(); /*get the text*/

			$(this).children('span').attr('aria-label', text); /*Add aria-label*/
		});
	}

	function topFocus() {
		// focus on skip to main content link on click
		$('#pxBackToTop').on('click', function () {
			$('#top').focus();
		});
	}


	return {
		init: init,
		getUrlParams: getUrlParams,
	};
})();
